import * as React from 'react';
import { OnWhen } from '@cvent/carina/components/OnWhen';
import { Button } from '@cvent/carina/components/Button';
import { DollarSignIcon } from '@cvent/carina/components/Icon';
const discountIcon = require('../../../assets/icons/discount.svg');

import { toUSD } from '@weddingspot/ws-core-components';
import { Search } from '@weddingspot/ws-api-client';
import { FeatureFlagContext, FLAG_SRP_PRICE_VENUE_CTA } from '@weddingspot/ws-core-components';
import cn from 'classnames';
import { SRP_VIEWS } from '../../../constants';

const _styles = require('../venueCard.scss');

interface OldBottomRowProps {
    venue: Search.SearchResult;
    contactAvailable: boolean;
    handlePriceVenueClick: (e: React.SyntheticEvent) => void;
    srpView?: string;
}

const OldBottomRow = (props: OldBottomRowProps) => {
    const { venue, contactAvailable, handlePriceVenueClick, srpView } = props;

    const { flagEnabled } = React.useContext(FeatureFlagContext);

    return (
        <div className={cn(_styles.bottomRow, { [_styles.bottomRow_noMargin]: srpView == SRP_VIEWS.LIST })}>
            <div className={_styles.bottomRowContent}>
            <div className={cn(_styles.priceAndCapacity, { [_styles.alignCenter]: srpView == SRP_VIEWS.LIST })}>
                {venue.discounts_available && <img className={_styles.discountIcon} src={discountIcon} alt='discount available' />}
                {!venue.discounts_available && !!venue.starting_at && !!venue.max_capacity && (
                    <div className={cn(_styles.dollarSignIcon, { [_styles.dollarSignIcon_show]: srpView == SRP_VIEWS.LIST })}>
                        <DollarSignIcon />
                    </div>
                )}
                {!!venue.starting_at && !!venue.max_capacity && (
                    <div className={cn(_styles.budgetRange, { [_styles.budgetRange_fullWidth]: srpView == SRP_VIEWS.LIST })} itemProp='priceRange'>
                        Starting at <b>{toUSD(venue.starting_at)}</b> for <b>{venue.max_capacity}</b> Guests
                    </div>
                )}
            </div>

            <div className={cn(_styles.buttonContainer, { [_styles.alignCenter]: srpView == SRP_VIEWS.LIST })}>
                <div className={'onWhenM'}>
                    <OnWhen m={true} l={true} xl={true}>
                        <Button
                            text={contactAvailable ? 'Contact Venue' : venue.cta_button.label}
                            onClick={handlePriceVenueClick}
                            size='l'
                        />
                    </OnWhen>
                </div>
                <div className={'onWhenS'}>
                    <OnWhen s={true} m={true}>
                        <Button
                            appearance={flagEnabled(FLAG_SRP_PRICE_VENUE_CTA) ? 'filled' : undefined}
                            text={contactAvailable ? 'Contact Venue' : venue.cta_button.label}
                            onClick={handlePriceVenueClick}
                            size='l'
                        />
                    </OnWhen>
                </div>
            </div>
            </div>
        </div>
    );
};

export default OldBottomRow;
